function presentations() {
	const presentationsSection = document.querySelector('main.subpage.presentations');
	if (!presentationsSection) return;

	// const searchInput = presentationsSection.querySelector('.search-input');
	// const presentationItems = presentationsSection.querySelectorAll('.presentation-item');

	// const filterPresentations = (searchValue) => {
	//     const searchTerm = searchValue.toLowerCase().trim();
	//
	//     presentationItems.forEach(item => {
	//         const title = item.querySelector('.title').textContent.toLowerCase();
	//
	//         if (searchTerm === '' || title.includes(searchTerm)) {
	//             item.style.display = '';
	//         } else {
	// 			item.style.display = 'none';
	//         }
	//     });
	//
	//     const visiblePresentations = Array.from(presentationItems).some(
	//         item => item.style.display !== 'none'
	//     );
	//
	// 	const noResultsMessage = presentationsSection.querySelector('.no-results-message');
	// 	if (!visiblePresentations) {
	// 		noResultsMessage.style.display = 'block';
	// 	} else {
	// 		noResultsMessage.style.display = 'none';
	// 	}
	// };

	// if (searchInput) {
	//     searchInput.addEventListener('input', (e) => {
	//         filterPresentations(e.target.value);
	//     });
	// }
}
